import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StudentAttendanceRoutingModule } from './student-attendance-routing.module';
import { StudentAttendanceLinkComponent } from './student-attendance-link/student-attendance-link.component';
import { StudentAttendanceComponent } from './student-attendance/student-attendance.component';
import { StudentAttendanceFilterComponent } from './student-attendance-filter/student-attendance-filter.component';
import { StudentAttendanceCampusComponent } from './student-attendance-campus/student-attendance-campus.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    StudentAttendanceLinkComponent,
    StudentAttendanceComponent,
    StudentAttendanceFilterComponent,
    StudentAttendanceCampusComponent
  ],
  imports: [
    CommonModule,
    StudentAttendanceRoutingModule,
    AcademicFormModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    AgGridModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class StudentAttendanceModule { }
